import script from "./ProductOptions.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductOptions.vue?vue&type=script&setup=true&lang=js"

import "./ProductOptions.vue?vue&type=style&index=0&id=9d75f312&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9d75f312"]])

export default __exports__